<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Contratos</div>
  <!--  @if (checkPermission('criar')) {-->

  <!--  }-->
</div>

<div>
  <search-contract [search]="inputSearch" (responseSearch)="search($event)" />
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--    <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    <form-client-search-->
    <!--      [search]="inputSearch"-->
    <!--      [listSearch]="listSearch"-->
    <!--      (responseSearch)="search($event)"-->
    <!--    />-->
    <!--    }-->
    <div>
      @if (!loading) {
        <div>
          @if (itemsList.length > 0) {
            <table-list-contract
              [dataSource]="itemsList"
              [columns]="columns"
              (selectItem)="editItem($event)"
              (viewItem)="editItem($event)"
              (cancelContract)="cancelContract($event)"
            />
          } @else {
            <div>
              <h3 class="text-center">Nenhum registro encontrado.</h3>
            </div>
          }
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
            <!-- <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            /> -->
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
